import { useTranslation } from "react-i18next";
import { Stack } from "../Stack";
import { Service } from "./Service";
import "./style.css";

type Services = {
  wifi?: boolean;
  doublebeds: number;
  singlebeds: number;
  sofabeds: number;
  hasairconditioning?: boolean;
};

export const HouseServices = ({
  doublebeds,
  singlebeds,
  sofabeds,
  hasairconditioning,
  wifi,
}: Services) => {
  const { t } = useTranslation();
  return (
    <Stack
      flexDirection="row"
      wrap
      flex={1}
      justifycontent="center"
      alignitems="center"
      className="house-services"
      gap={60}
    >
      {wifi && <Service iconName="WifiLucide" serviceDescription="WiFi" />}
      {hasairconditioning && (
        <Service iconName="AirConditioning" serviceDescription="AC" />
      )}
      {doublebeds > 0 && (
        <Service
          iconName="DoubleBed"
          serviceDescription={t("double-bed")}
          quantity={doublebeds}
        />
      )}
      {singlebeds > 0 && (
        <Service
          iconName="SingleBed"
          serviceDescription={t("single-bed")}
          quantity={singlebeds}
        />
      )}
      {sofabeds > 0 && (
        <Service
          iconName="SofaLucide"
          serviceDescription={t("sofa-bed")}
          quantity={sofabeds}
        />
      )}
    </Stack>
  );
};
